import {
  FormInput,
  SubmitButton,
  WelcomeMessage,
} from "@/components/ui";
import { motion } from "framer-motion";
import logo from "@/assets/img/icons/logo.svg";

interface ForgotPasswordStep1Props {
  onSubmit: () => void;
  email: string;
  setEmail: (email: string) => void;
  emailError: string | null;
}

export const ForgotPasswordStep1: React.FC<ForgotPasswordStep1Props> = ({
  onSubmit,
  email,
  setEmail,
  emailError,
}) => (
  <motion.div
    initial={{ opacity: 0, x: 100 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -100 }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
    className="h-full"
  >
    <div className="flex flex-col items-center mb-6">
      <img
        src={logo}
        alt="logo"
        className="w-50 h-50 mb-2 mt-4"
      />
    </div>

    <WelcomeMessage
      text="Введите почту связанную с вашим аккаунтом, что бы получить инструкции для восстановления пароля"
      className="rounded-lg"
      textAlign="left"
      showOverlay={false}
    />
    <div className="flex flex-col gap-2 w-full">
      <FormInput
        id="email"
        label="Email"
        type="email"
        value={email}
        onChange={setEmail}
        error={emailError}
      />
      <SubmitButton className="mt-10" text="Отправить" onClick={onSubmit} />
    </div>
  </motion.div>
);

export default ForgotPasswordStep1;
